import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import PropTypes from "prop-types";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import { TableHead, TableCell, TableRow } from "@material-ui/core";
import { formatHeaderName } from "../../../utils/common/index";
import MnpActivationViews from "../../../views/retailerPerformance/retailerPerfDashboard/mnpActivation";

const useStyles = makeStyles({
  table: {
    minWidth: 500,
  },
  rows: {
    padding: 6,
    textAlign: "right",
  },
  container: {
    maxHeight: 500,
  },
});
const StyledTableCell = withStyles((theme) => ({
  head: {
    //backgroundColor: "#dff0d8",
    borderColor: "#7d8675",
    color: "#3c763d",
    textAlign: "center",
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

export default function MnpActivation(props) {
  const classes = useStyles();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(20);
  let otherRetailerLink = false;
  const [showTable, setShowTable] = useState(false);
  const { mnpActivationObj } = useSelector(
    (state) => state.retailerPerformanceReducer
  );
  let { mnpActivationData } = mnpActivationObj;
  let {
    url,
    filterValue,
    headerSelectedDateFrom,
    headerSelectedDateTo,
    triggerMnpActivationAPI,
    searchFields,
  } = props;
  const dispatch = useDispatch();
  let headerKeys,
    sortedRetailerData,
    top20RetailerData,
    individualColumns,
    columnTotal,
    top20ColumnTotal;
  let retailerData = Object.values(mnpActivationData)[0];
  const headers = {
    id: searchFields?.partner?.partnerId
      ? searchFields?.partner?.partnerId
      : searchFields?.partner
      ? searchFields?.partner?.split("-")?.pop()?.trim()
      : filterValue.orgId,
    partnerRoleType:
      searchFields?.partner?.partnerName?.split("-")?.[0]?.trim() ??
      filterValue.selectedPartnerRoleName,
    fromDate: headerSelectedDateFrom,
    toDate: headerSelectedDateTo,
    section: props.section,
    moduleName: props.moduleName,
    isRedisActive: "YES",
  };

  useEffect(() => {
    function fetchMnpActivationData() {
      const obj = {
        headers: {
          "Content-Type": "application/json",
          url: url,
        },
        params: headers,
      };
      return dispatch(triggerMnpActivationAPI(obj));
    }

    fetchMnpActivationData();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [triggerMnpActivationAPI, headerSelectedDateFrom, headerSelectedDateTo]);

  const extractColumns = (item) => {
    const {
      partnerName,
      jioCenter,
      jioPointId,
      parentId,
      partnerId,
      primaryNo,
      runDate,
      rrank,
      ...other
    } = item;
    return { ...other };
  };

  if (retailerData && retailerData.length) {
    const tableHeaders = Object.keys(retailerData[0]);
    const {
      jioCenter,
      jioPointId,
      parentId,
      partnerId,
      runDate,
      rrank,
      ...headerFields
    } = tableHeaders;
    headerKeys = Object.values(headerFields).map((item) =>
      formatHeaderName(item)
    );
    sortedRetailerData = retailerData.sort((a, b) =>
      +a.lfmMnpActivations > +b.lfmMnpActivations ? -1 : 1
    );
    // console.log(headerKeys)
    top20RetailerData = sortedRetailerData.slice(0, 20);
    const top20IndividualColumn = top20RetailerData.map((value) =>
      extractColumns(value)
    );
    top20ColumnTotal = {};
    top20IndividualColumn.map((item) => {
      return Object.entries(item).map(([key, value]) => {
        return top20ColumnTotal[key]
          ? (top20ColumnTotal[key] += +value)
          : (top20ColumnTotal[key] = +value);
      });
    });

    individualColumns = retailerData.map((value) => extractColumns(value));
    columnTotal = {};
    individualColumns.map((item, key) => {
      return Object.entries(item).map(([key, value]) => {
        return columnTotal[key]
          ? (columnTotal[key] += +value)
          : (columnTotal[key] = +value);
      });
    });

    retailerData.length > 20
      ? (otherRetailerLink = true)
      : (otherRetailerLink = false);
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const preventDefault = (event) => event.preventDefault();

  const handlePaginationOption = (event) => {
    preventDefault(event);
    setShowTable(true);
    setPage(1);
  };

  const backToTop20 = (event) => {
    preventDefault(event);
    setShowTable(false);
    setPage(0);
  };
  const renderTableHeader = (headerKeys) => (
    <TableHead>
      <TableRow>
        <StyledTableCell>{headerKeys[4]}</StyledTableCell>
        <StyledTableCell></StyledTableCell>
        <StyledTableCell>{headerKeys[5]}</StyledTableCell>
        <StyledTableCell>{headerKeys[6]}</StyledTableCell>
        <StyledTableCell>{headerKeys[7]}</StyledTableCell>
        <StyledTableCell>{headerKeys[8]}</StyledTableCell>
        <StyledTableCell>{headerKeys[9]}</StyledTableCell>
        <StyledTableCell>{headerKeys[10]}</StyledTableCell>
      </TableRow>
    </TableHead>
  );
  return (
    <MnpActivationViews
      filterValue={props.filterValue}
      timestampArr={props.timestampArr}
      mnpActivationObj={mnpActivationObj}
      retailerData={retailerData}
      classes={classes}
      showTable={showTable}
      page={page}
      backToTop20={backToTop20}
      section={props.section}
      renderTableHeader={renderTableHeader}
      headerKeys={headerKeys}
      rowsPerPage={rowsPerPage}
      sortedRetailerData={sortedRetailerData}
      StyledTableCell={StyledTableCell}
      otherRetailerLink={otherRetailerLink}
      handlePaginationOption={handlePaginationOption}
      columnTotal={columnTotal}
      top20ColumnTotal={top20ColumnTotal}
      handleChangePage={handleChangePage}
      handleChangeRowsPerPage={handleChangeRowsPerPage}
    />
  );
}

MnpActivation.propTypes = {
  url: PropTypes.string,
  filterValue: PropTypes.object,
  headerSelectedDateFrom: PropTypes.string,
  headerSelectedDateTo: PropTypes.string,
  triggerMnpActivationAPI: PropTypes.func,
};
